module.exports = __webpack_public_path__ + "img/contact_show_btn.23387123.png";